<div class="limit-toast">
  <div class="top-section">
    <div class="icon">
      <mat-icon>error_outline</mat-icon>
    </div>

    <div class="text">
      <p class="title">{{ 'Limit Almost Reached' | translate }}</p>
      <p class="subtitle">
        {{ 'You have' | translate }} <strong>{{ remaining }}</strong> {{ 'products left on your free plan.' | translate }}
      </p>
    </div>

    <button class="close-btn" (click)="closed.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <button class="upgrade-btn" (click)="upgrade.emit()">{{ 'Upgrade Plan' | translate }}</button>
</div>
